import { useAppServices } from "hook/services";
// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import SoftUITabs from "./SoftUITabs/SoftUITabs";
import { useParams } from "react-router-dom";
import { useAgencyInfo } from "context/agency";
import ContactTab from "../Accounts/components/Tabs/ContactTab";
import Business from "../Accounts/components/Tabs/Business";
import Events from "./components/Tabs/Events";
import Tabs from "../components/Tabs";
import PageTitle from "../components/PageTitle";
import "../Accounts/components/Tabs/accountDetailTabs.css";
import "./consumersCompact.css";

function AccountDetail() {
  const [agency] = useAgencyInfo();
  const { id } = useParams(); // Extract the ID from the URL
  const navigate = useNavigate();
  const AppService = useAppServices();
  const [formData, setformData] = useState({});

  const onLoad = async () => {
    const url = window.location.href;
    const parts = url.split("/"); // Split the URL by '/'
    const lastPart = parts[parts.length - 1]; // Get the last part of the URL
    const { response } = await AppService.accounts.getbyid({
      query: `id=${lastPart}`,
    });
    if (response) {
      setformData(response.data);
    }
  };
  useEffect(() => {
    onLoad();
  }, []);
  let tabsData = [
    {
      label: "Personal Details",
      content: <ContactTab handleRefresh={onLoad} formData={formData} />,
    },
    { label: "Followed Business", content: <Business /> },
    { label: "Events", content: <Events handleRefresh={onLoad} formData={formData} /> },
  ];
  return (
    <PageLayout>
      <SoftBox className="sd-consumers-detail sd-page" style={{ margin: "10px 20px" }} pt={6} pb={3}>
            <div className="sd-page__header">
            <PageTitle>Consumers</PageTitle>
            <span
              className="sd-consumers-detail__breadcrumb"
              style={{ fontSize: "14px", cursor: "pointer" }}
              onClick={() => navigate(-1)}
            >
              {" "}
              {"Consumer"} {`>`}
            </span>{" "}
            <span className="sd-consumers-detail__breadcrumb" style={{ fontSize: "14px" }}>
              {" "}
              {formData.business_name}
            </span>
            <PageTitle detail className="my-3percent">
              {formData.business_name}{" "}
              <span className="alert-success-new">
                {formData?.type === "premium" ? formData?.type : "Free"}
              </span>
            </PageTitle>
            </div>
            <Tabs tabsData={tabsData} />
      </SoftBox>
    </PageLayout>
  );
}

export default AccountDetail;
